import { getSLEntry } from "./SLCreateRequests";
import { ISLEntryResponse, IAuditInfo } from "./SLCreateSchemas";
import { AccountTypeOptions } from "./SLCreateLineItems/LineItemsUtilities";
import { trimNullableString } from "../../services/SanitizationHelpers";
import { LineItemsResponse } from "./SLCreateLineItems/LineItemsSchemas";
import { IUserProviderState } from "../../contexts/UserContext";

function parseAuditInfo(auditInfo: IAuditInfo[]): IAuditInfo[] {
  return auditInfo.map((item: IAuditInfo) => {
    return {
      modifiedOn: item.modifiedOn,
      actionName: item.actionName,
      actionBy: item.actionBy,
      actionByFullName: item.actionByFullName
    } as IAuditInfo;
  });
}

const mapAccountTypeInput = (inputAccountType: string | null): string => {
  let outputAccountType = trimNullableString(inputAccountType);
  const acc = AccountTypeOptions.slice(1).filter(
    (keyValue) => (keyValue.key as string).toUpperCase() === outputAccountType.toUpperCase()
  );
  if (acc.length > 0) {
    outputAccountType = acc[0].text;
  }
  return outputAccountType;
};

export function sanitizeLineItems(lineItemsList: LineItemsResponse[]): LineItemsResponse[] {
  const lineItems = lineItemsList.map((lineItemRow: LineItemsResponse) => {
    return {
      account: lineItemRow.account,
      accountType: mapAccountTypeInput(lineItemRow.accountType),
      costCenter: lineItemRow.costCenter,
      internalOrder: lineItemRow.internalOrder,
      taxCode: lineItemRow.taxCode,
      taxJurisdictionCode: lineItemRow.taxJurisdictionCode,
      materialGroup: lineItemRow.materialGroup,
      tradingPartner: lineItemRow.tradingPartner,
      profitCenter: lineItemRow.profitCenter,
      lineAmount: lineItemRow.lineAmount,
      lineDesc: lineItemRow.lineDesc
    } as LineItemsResponse;
  });
  return lineItems as LineItemsResponse[];
}

export function sanitizeRegularEntryFromApi(result: ISLEntryResponse): ISLEntryResponse {
  const entryResponse = {
    slEntryId: result.slEntryId,
    companyCode: trimNullableString(result.companyCode),
    invoiceDate: result.invoiceDate,
    postingDate: result.postingDate,
    translationDate: result.translationDate,
    reference: result.reference,
    documentType: trimNullableString(result.documentType),
    credit: result.credit || "0",
    debit: result.debit || "0",
    amount: result.amount || "0",
    currency: trimNullableString(result.currency),
    headerText: result.headerText,
    lineItems: sanitizeLineItems(result.lineItems),
    comments: result.comments || [],
    attachments: result.attachments || [],
    additionalPoster: result.additionalPoster,
    jeStatus: result.jeStatus,
    fiscalYear: result.fiscalYear,
    fiscalPeriod: result.fiscalPeriod,
    slDocNumber: result.slDocNumber,
    purpose: result.purpose,
    rowWeightage: result.rowWeightage || 0,
    batchRefguid: result.batchRefguid,
    userPersona: result.userPersona,
    auditInfo: parseAuditInfo(result.auditInfo || []),
    rowVer: result.rowVer,
    hasWriteAccess: result.hasWriteAccess
  } as ISLEntryResponse;
  return entryResponse;
}

export async function getEntryFromApi(
  slEntryId: number,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ISLEntryResponse> {
  const result = await getSLEntry(slEntryId, getTokenFn);
  if (result === undefined) {
    throw new Error("no result from API");
  }

  const slEntry = sanitizeRegularEntryFromApi(result.data);
  return slEntry;
}
